import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ConnectedModal from 'containers/ConnectedModal';
import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';
import { hideModal } from 'redux/modules/modal';
import EddyEditTranscriptModalContents from './EddyEditTranscriptModalContents';

export interface EddyEditTranscriptModalProps {}

const EddyEditTranscriptModal: React.FC<EddyEditTranscriptModalProps> = () => {
  const { params } = useConnectedModal('EddyEditTranscript');

  const { eddyProjectId, embedConfig } = params ?? {};

  const dispatch = useDispatch();

  const handleSave = useCallback((): void => {
    dispatch(hideModal(embedConfig));
  }, [dispatch, embedConfig]);

  const handleCancel = useCallback((): void => {
    dispatch(hideModal());
  }, [dispatch]);

  return (
    <ConnectedModal name="EddyEditTranscript" isFullScreen>
      <EddyEditTranscriptModalContents
        {...{ eddyProjectId, embedConfig }}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </ConnectedModal>
  );
};

export default EddyEditTranscriptModal;
